import React from "react";
import { Stack, Box, Text } from "@origin-digital/ods-core";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import EditButton from "./EditButton";

interface ReadOnlySecondaryAccountHolderProps {
  secondaryFirstName: string;
  secondaryLastName: string;
  secondaryDateOfBirth: Date | null;
  secondaryPhone: string;
  secondaryEmail: string;
  formatDate: (date: Date | null) => string;
  onEdit?: () => void;
}

const ReadOnlySecondaryAccountHolder: React.FC<
  ReadOnlySecondaryAccountHolderProps
> = ({
  secondaryFirstName,
  secondaryLastName,
  secondaryDateOfBirth,
  secondaryPhone,
  secondaryEmail,
  formatDate,
  onEdit,
}) => (
  <Stack>
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Text weight="medium" tone="neutralDark">
        Secondary holder
      </Text>
      {onEdit ? <EditButton onClick={onEdit} /> : null}
    </Box>
    <Stack>
      {/* Name */}
      <ReadOnlyTextField
        label="Name"
        value={`${secondaryFirstName} ${secondaryLastName}`}
      />
      {/* End Name */}
      {/* DOB + Phone */}
      <Box
        display="flex"
        flexDirection={{
          xs: "column",
          sm: "row",
        }}
      >
        {/* Date of birth */}
        <ReadOnlyTextField
          label="Date of birth"
          value={formatDate(secondaryDateOfBirth)}
        />
        {/* End Date of birth */}
        {/* Phone */}
        <ReadOnlyTextField label="Phone" value={secondaryPhone} />
        {/* End Phone */}
      </Box>
      {/* End DOB + Phone */}
      {/* Email */}
      <ReadOnlyTextField label="Email" value={secondaryEmail} />
      {/* End Email */}
    </Stack>
  </Stack>
);

export default ReadOnlySecondaryAccountHolder;
